const digitalSigningStatus = {
  sentToCustomer: 'DIGITAL_SENT_TO_CUSTOMER',
  signCompleted: 'DIGITAL_SIGN_COMPLETED',
  openedByCustomer: 'DIGITAL_OPENED_BY_CUSTOMER',
  signedByCustomer: 'DIGITAL_SIGNED_BY_CUSTOMER',
  documentSignedByCustomer: 'DIGITAL_DOCUMENT_SIGNED_BY_CUSTOMER',
  manualSignPending: 'MANUAL_SIGNING_PENDING',
  manualSignCompleted: 'MANUAL_SIGNING_COMPLETED',
  failedToSend: 'FAILED_TO_SEND_DIGITAL_SIGN_CONTRACT',
}
export default digitalSigningStatus
